import { Component, OnInit, Inject } from '@angular/core';
import { ManageUsersService } from '../../services/manage-users/manage-users.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-manage-user-delete-dialogue',
  templateUrl: './manage-user-delete-dialogue.component.html',
  styleUrls: ['./manage-user-delete-dialogue.component.css']
})
export class ManageUserDeleteDialogueComponent implements OnInit {
  id: any;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  constructor(public dialogRef: MatDialogRef<ManageUserDeleteDialogueComponent>, private manageUserService: ManageUsersService, @Inject(MAT_DIALOG_DATA) public siteAdminData: any) { }

  ngOnInit() {
   
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteSiteAdmin() {
    this.id = this.siteAdminData;
    this.manageUserService.deleteSiteAdmin(this.id).subscribe(res => {
      this.manageUserService.load.next('success');
      localStorage.removeItem('SiteAdmindocId');
      this.onNoClick();
    }, error => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/manage-user-delete-dialogue/manage-user-delete-dialogue.component.ts